import { ClientId } from "@sp-crm/core";
import { InlineBanner } from "components/ui/inline-banner";
import {
    ClientTransferRequestStatus,
    useFindClientTransferRequestByClientIdQuery,
} from "generated/graphql";
import React from "react";
import { useCurrentTenant } from "store/selectors/hooks";
import { QueryRenderer } from "../show-client/community-comparison/query-renderer";

export const ClientTransferBanner: React.FC<{ clientId: ClientId }> = props => {
    const tenant = useCurrentTenant();
    const { clientId } = props;
    const query = useFindClientTransferRequestByClientIdQuery({
        clientId,
    });
    return (
        <QueryRenderer query={query} name="findClientTransferRequestByClientId">
            {data => {
                if (
                    data.findClientTransferRequestByClientId?.status ===
                    ClientTransferRequestStatus.Accepted
                )
                    return (
                        <div>
                            <InlineBanner type="warning">
                                <p>
                                    This client has been transferred to an advisor outside
                                    of {tenant.name}. Consider closing this client.
                                </p>
                            </InlineBanner>
                        </div>
                    );

                if (
                    data.findClientTransferRequestByClientId?.status ===
                    ClientTransferRequestStatus.Pending
                )
                    return (
                        <div>
                            <InlineBanner type="warning">
                                <p>
                                    This client is in the process of being transferred to
                                    an advisor outside of {tenant.name}.
                                </p>
                            </InlineBanner>
                        </div>
                    );
                return <></>;
            }}
        </QueryRenderer>
    );
};
